import i18n from '@/i18n';

const editChild = {
  path: ':id(\\d+)',
  name: 'pins-edit',
  meta: {
    loadState: true,
    auth: true,
    isAuthPage: false,
    permissions: [
      {
        subject: 'pin',
        actions: ['list-all'],
      },
    ],
    title: i18n.global.t('pins'),
  },
  component: () => import('../../views/pins/Edit.vue'),
};

export default [
  {
    path: '/pins',
    name: 'pins',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'pin',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('pins')
    },
    component: () => import('../../views/pins/Index'),
    children: [
      {
        path: 'new',
        name: 'pins-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'pin',
              actions: ['list-all'],
            },
          ],
          title: i18n.global.t('pins'),
        },
        component: () => import('../../views/pins/AddNew.vue'),
      },
      editChild,
    ],
  },
  {
    path: '/pins/running',
    name: 'running-pins',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'pin',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('running_pins')
    },
    component: () => import('../../views/pins/Index'),
    children: [
      {
        path: 'new',
        name: 'running-pins-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'pin',
              actions: ['list-all'],
            },
          ],
          title: i18n.global.t('running_pins'),
        },
        component: () => import('../../views/pins/AddNew.vue'),
      },
      {
        ...editChild,
        name: 'running-pins-edit',
      },
    ],
  },
  {
    path: '/pins/:country/:id(\\d+)',
    name: 'pin-details',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'pin',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('pin_details')
    },
    component: () => import('../../views/pins/Single'),
  },
];
